import React, {useState, useEffect, useRef } from 'react';
import { f7,Page, Icon, Link, Input, Button, Popup } from 'framework7-react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';

const ConfirmBid = ({f7route}) => {
    const { date } = f7route.params;
    const [data , setConfirmData] = useState([]);
    useEffect (()=>{
        axios.get(API_BASE_URL + 'restacceptorder' , {
        headers: {
            'Authorization': 'Basic ' + API_AUTH
        },
        params: {
            rest_id : localStorage.getItem('id'),
            limits : 100,
            date : date 
        }
        })
        .then(response => { setConfirmData(response.data);} )
        .catch(error => console.log(error));
    }, [date])
    
    return(
        <Page className='bg-white'>
          <div className="container container-table ">
            <div className="row vertical-center-row col-md-12 col-md-offset-12">
                <header className="section-t-space">
                  <div className="container-lg custom-container p-0">
                    <div className="header-panel">
                        <Link href="#" back reloadAll><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                        <h2>Confirm Bid</h2>
                        {/* <Link href="#"><Icon ios="material:edit" aurora="material:edit" md="material:edit" className='theme-dark'></Icon></Link> */}
                    </div>
                  </div>
                </header>
                <section className="section-b-space profile-form mt-3">
                  <div className='custom-container p-0'>
                    <div className='row gy-3 '>
                      {data.length > 0 ? (
                        data.map(item => (
                          <div className='bid-web-view-div'>
                            <div className="custom-container p-0">
                              <a href={`/orderview/${item.order_id}/`}>
                              <div className="vertical-product-box order-box">
                                <div className="vertical-box-img">
                                  <img className="img-fluid img" src={require("./../images/events.jpg")} alt="vp1" />
                                </div>
                                <div className="vertical-box-details">
                                  <div className="vertical-box-head">
                                    <div className="restaurant">
                                      <h5 className="dark-text">{item.event_name}</h5>
                                      <h5 className="text-success">{item.order_event_status}</h5>
                                    </div>
                                    <h6 className="food-items mb-2"><Icon ios="material:location_on" aurora="material:location_on" md="material:location_on" className='text-success text-3'/> {item.add_lin_1} {item.add_lin_2} {item.city} {item.state} {item.zip_code}</h6>                    
                                  </div>
                                  <div className="reorder">
                                    <h6 className="rating-star">
                                      <ul className="timing">
                                        <li><Icon ios="material:groups" aurora="material:groups" md="material:groups" className='text-muted text-4'/> {item.event_adult_size + item.event_kids_size} </li>
                                        <li><Icon ios="material:event" aurora="material:event" md="material:event" className='text-muted text-4'/> {item.date}</li>
                                        {/* <li className="text-success"> {item.order_status}</li> */}
                                      </ul>                      
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              </a>
                            </div>
                          </div>            
                        ))
                        ) : (
                          <div className="custom-container p-0">
                            <div className="empty-tab">
                              <h2>No Event Order Found!!</h2>
                              <h5 className="mt-3">You have currently no event orders .</h5>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </section>
            </div>
          </div>
        </Page>
    )
    

};
export default ConfirmBid;